import type {OrganizationManagerModels} from '@yandex-data-ui/cloud-schemas';

export interface CloudOrganization
    extends Omit<OrganizationManagerModels.Organization, 'createdAt'> {
    cloudId?: string;
}

export interface UserOrganization {
    title?: string;
    cloudId?: string;
}

export interface OrganizationIdentity {
    dir_id?: string;
    cloud_id?: string;
}

export interface CollaborationOrganization {
    id: string;
    title: string;
    directoryOrganizationId: string;
}

export enum UserSource {
    Passport = 'passport',
    Cloud = 'cloud',
}

export enum ComOrgSyncStatus {
    Syncing = 'syncing',
    Online = 'online',
    Disabled = 'disabled',
    UpdateScheduled = 'update_scheduled',
}

export enum ComService {
    Wiki = 'wiki',
    Forms = 'forms',
    Tracker = 'tracker',
}

export enum ComGroupSource {
    Dir = 'dir',
    Cloud = 'cloud',
    Com = 'com',
    Staff = 'staff',
}

export enum ComOrgSource {
    Dir = 'dir',
    Cloud = 'cloud',
}

export interface ComGroupIdentity {
    src: ComGroupSource;
    id: string;
}

export interface ComOrgIdentity {
    src: ComOrgSource;
    id: string;
}

export interface ComFederation {
    identity: ComOrgIdentity;
    status: ComOrgSyncStatus;
}

export interface ComActiveOrganization {
    collab_id: string;
    status: ComOrgSyncStatus;
    banned?: boolean;
    display_name: string;
    logo?: string;
    enabled_services: ComService[];
    federations: ComFederation[];
}

export interface ComInactiveOrganization {
    identity: ComOrgIdentity;
    hybrid: boolean;
    title: string;
}

export interface ComOrganizationList {
    active: ComActiveOrganization[];
    inactive: ComInactiveOrganization[];
}

export interface OrganizationContext {
    cloudOrgId?: string;
    directoryOrgId?: string;
    collabOrgId?: string;
}
